export default __webpack_public_path__ + "static/media/card.b05a7b66.wav";